import VideoControlButton from './VideoControlButton'
import { IconS24Bin24, IconS24Play24 } from '@is24/cosma-ui-icons'
import React from 'react'

import styles from './VideoControlButtons.module.css'
import { useTranslation } from 'react-i18next'

type VideoControlButtonsProps = {
  onPreviewClick: () => void
  onDeleteClick: () => Promise<void>
}

const VideoControlButtons: React.FC<VideoControlButtonsProps> = ({ onPreviewClick, onDeleteClick }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.videoButtonsContainer} data-testid={'video-control-buttons'}>
      <div className={'absolute-reference'}>
        <VideoControlButton
          icon={<IconS24Play24 />}
          onClick={onPreviewClick}
          ariaLabel={t('button.preview')}
          testId='preview-video-button'
          styleClasses={'margin-right-s float-left'}
        />
        <VideoControlButton
          icon={<IconS24Bin24 />}
          onClick={onDeleteClick}
          ariaLabel={t('button.delete')}
          testId='delete-video-button'
          styleClasses={'float-right'}
        />
      </div>
    </div>
  )
}

export default VideoControlButtons
